import './styles.css'

const Header = () => {
  return (
    <header>
      <h1>GitFind</h1>
    </header>
  )
}

export { Header }
